"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tripContentAsString = void 0;
const filterBoolean_1 = __importDefault(require("../util/filterBoolean"));
const deserializeNumber_1 = require("./deserializeNumber");
const deserializeString_1 = require("./deserializeString");
class TripContent {
    constructor(title, quantity) {
        this.title = title;
        this.quantity = quantity;
    }
    static deserialize(value) {
        if (typeof value !== 'object')
            throw new Error('Not an object');
        if (!value.title && !value.quantity)
            throw new Error('Invalid object (must have title and/or quantity');
        return new TripContent((0, deserializeString_1.deserializeString)(value.title), (0, deserializeNumber_1.deserializeNumber)(value.quantity));
    }
}
exports.default = TripContent;
function tripContentAsString(content) {
    return (0, filterBoolean_1.default)([content.quantity && `${content.quantity} x `, content.title]).join(' ');
}
exports.tripContentAsString = tripContentAsString;
